import './src/styles/global.css';
import pageElement from './wrap-page-element';
import wrapWithProvider from './wrap-with-provider';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = pageElement;

// Suppress defaultProps warning
export const onClientEntry = () => {
  const originalError = console.error;
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('Support for defaultProps will be removed')) {
      return;
    }
    originalError(...args);
  };
};
